// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Behavior } from '@shared/commons/cache/Algorithm/GainersLosers/GainerLoserData';
import { BaseItem, ColumnData } from './BaseItem';
import { QuickTableComparingType } from '@shared/utils/QuickTableMisc/QuickTableComparingType';
import { ColumnParams } from './ColumnParams';
import { StringUtils } from '@shared/utils/StringUtils';
import { TableTotalsVisibility } from './TableTotalsVisibility';
import { QTAlignment } from '../elements/QuickTable/QuickTableColumn';
import { VolumeFormatter } from '@shared/utils/Volume/VolumeFormatter';
import { ThemeManager } from '../misc/ThemeManager';
export class GainersLosersItem extends BaseItem {
    constructor(data) {
        super(null);
        this.Id = GainersLosersItem.StaticId;
        GainersLosersItem.StaticId++;
        this.Data = data;
    }
    GetItemId() {
        return this.Id;
    } // public ItemId (): number { return this.Id; }
    getQuickTableCellForeground(column) {
        const colors = ThemeManager.colors;
        if (column === GainersLosersItem.SYMBOL_COL_INDEX && !isNullOrUndefined(this.Data)) {
            return this.Data.Behavior === Behavior.Gainer ? colors.positiveColor : colors.negativeColor;
        }
    }
    getColumnValue(column) {
        var _a, _b;
        switch (column) {
            case GainersLosersItem.SYMBOL_COL_INDEX:
                return this.Data.InstrumentName;
            case GainersLosersItem.CHANGE_COL_INDEX:
                return this.Data.InterestChange;
            case GainersLosersItem.VOLUME_COL_INDEX:
                return (_a = this.Data.Volume) !== null && _a !== void 0 ? _a : NaN;
            case GainersLosersItem.EXCHANGE_COL_INDEX:
                return this.Data.MarketDataExchange;
            case GainersLosersItem.LAST_COL_INDEX:
                return (_b = this.Data.LastPrice) !== null && _b !== void 0 ? _b : NaN;
        }
        return '';
    }
    getColumnData(column) {
        const value = this.getColumnValue(column);
        let formattedValue = '';
        switch (column) {
            case GainersLosersItem.VOLUME_COL_INDEX:
                formattedValue = VolumeFormatter.getVolumeFormat(value);
                break;
            case GainersLosersItem.LAST_COL_INDEX:
                formattedValue = isNaN(value) ? StringUtils.NOT_AVAILABLE : value.toString();
                break;
            default:
                formattedValue = value === null || value === void 0 ? void 0 : value.toString();
        }
        return new ColumnData(value, formattedValue);
    }
    ColumnCount() {
        return GainersLosersItem.columnsParams.length;
    }
    GetColumnParams(i) {
        const par = GainersLosersItem.columnsParams[i];
        par.Hidden = par.DefaultHidden;
        return par;
    }
    GetDataType(columnIndex) {
        return GainersLosersItem.dataTypes[columnIndex];
    }
}
GainersLosersItem.StaticId = 0;
// Static Columns
GainersLosersItem.dataTypes = [
    QuickTableComparingType.String,
    QuickTableComparingType.Double,
    QuickTableComparingType.Double,
    QuickTableComparingType.String,
    QuickTableComparingType.Double
];
GainersLosersItem.SYMBOL_COL_INDEX = 0;
GainersLosersItem.CHANGE_COL_INDEX = 1;
GainersLosersItem.VOLUME_COL_INDEX = 2;
GainersLosersItem.EXCHANGE_COL_INDEX = 3;
GainersLosersItem.LAST_COL_INDEX = 4;
GainersLosersItem.columnsParams = [
    new ColumnParams('panel.GainersLosersPanel.Item.Symbol', 40, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.GainersLosersPanel.Item.Change', 40, QTAlignment.Right, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.GainersLosersPanel.Item.Volume', 40, QTAlignment.Right, TableTotalsVisibility.None, false, false),
    new ColumnParams('InstrumentDetailsPanel.Exchange', 40, QTAlignment.Left, TableTotalsVisibility.None, false, false, true),
    new ColumnParams('panel.GainersLosersPanel.Item.Last', 40, QTAlignment.Right, TableTotalsVisibility.None, true, false)
];
